const ReferAFriendView = () => {
  return <div>ReferAFriendView</div>;
};

export default ReferAFriendView;
